// ─────────────────────────────────────────────────────────────────────────────
// Configuration des sections de l'application
//
// Une section correspond à une zone de l'appli (une route).
// Elle définit la classe CSS posée sur <body>, le titre et l'icône affichés
// dans la topbar.
//
// Pour ajouter une section : ajouter une entrée dans SECTION_CONFIG c'est tout.
// SECTION_CLASSES, PAGE_TITLES et PAGE_ICONS sont dérivés automatiquement.
// ─────────────────────────────────────────────────────────────────────────────

// Noms des classes CSS posées sur <body> — une par section
export type SectionClass =
  | 'section-login'
  | 'section-dashboard'
  | 'section-time-tracking'
  | 'section-sessions'
  | 'section-lieux'
  | 'section-activites'
  | 'section-dispositifs'
  | 'section-users'
  | 'section-participants';

// Source de vérité unique : route → classe CSS + titre + icône Material
const SECTION_CONFIG: Array<{
  route:   string;
  section: SectionClass;
  title:   string;
  icon:    string;
}> = [
  { route: '/auth/login',      section: 'section-login',         title: '',                          icon: 'login'          },
  { route: '/dashboard',       section: 'section-dashboard',     title: 'Tableau de bord',           icon: 'home'           },
  { route: '/time-tracking',   section: 'section-time-tracking', title: 'Saisie du temps',           icon: 'timer'          },
  { route: '/sessions',        section: 'section-sessions',      title: 'Saisie du temps',           icon: 'grid_on'        },
  { route: '/admin/lieux',     section: 'section-lieux',         title: 'Gestion des lieux',         icon: 'location_on'    },
  { route: '/admin/activites', section: 'section-activites',     title: 'Gestion des activités',     icon: 'local_activity' },
  { route: '/admin/dispositifs',section: 'section-dispositifs',  title: 'Gestion des dispositifs',   icon: 'stadium'        },
  { route: '/admin/users',     section: 'section-users',         title: 'Gestion des utilisateurs',  icon: 'group'          },
  { route: '/participants',    section: 'section-participants',   title: 'Gestion des participants',  icon: 'groups'         },
];

// ─── Exports dérivés automatiquement ─────────────────────────────────────────

export const SECTION_CLASSES = SECTION_CONFIG.map(c => c.section);

export const PAGE_TITLES: Record<SectionClass, string> =
  Object.fromEntries(SECTION_CONFIG.map(c => [c.section, c.title])) as Record<SectionClass, string>;

export const PAGE_ICONS: Record<SectionClass, string> =
  Object.fromEntries(SECTION_CONFIG.map(c => [c.section, c.icon])) as Record<SectionClass, string>;

export function getSectionClass(url: string): SectionClass | '' {
  return SECTION_CONFIG.find(c => url.startsWith(c.route))?.section ?? '';
}
